import { getImagesArray } from '../../../../hooks/useImagesArray';
import ImageViewer from '../../../ImageViewer';
import { Header } from '../../styles';
import { Container, Item, ItemLeft, ItemRight, SubTitle, Title, ViewerContainer } from './styles';

// const { imageArray } = getImagesArray(images || [], 10);

// return (
//   <ViewsAndLayoutsWrapper>
//     {imageArray.slice(1, 7).map((image, index) => (
//       <ViewsAndLayoutsListItem
//         key={index}
//         image={image}
//       />
//     ))}
//   </ViewsAndLayoutsWrapper>

const ItemComponent = ({ image }) => {
  return (
    <Item>
      <ItemLeft>
        <ViewerContainer>
          <ImageViewer
            imageId={image.imageId}
            fullscreen={false}
            containerStyle={{
              width: '64px',
              height: '64px',
            }}
          />
        </ViewerContainer>
      </ItemLeft>
      <ItemRight>
        <Title>{image.legend}</Title>
      </ItemRight>
    </Item>
  );
};

const ViewsAndLayoutsCompareComponent = ({ images }) => {
  const { imageArray } = getImagesArray(images || [], 7);

  return (
    <Container>
      {imageArray.map((image, index) => (
        <ItemComponent
          key={index}
          image={image}
        />
      ))}
    </Container>
  );
};

export default ViewsAndLayoutsCompareComponent;
